// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DU1GO","title":"styles_title__eADDY","message":"styles_message__IgrOB"};